import { ConcreteEncodable } from "./ConcreteEncodable";

import { AlgoHedgeConfigInfoImplEncoder } from "../../encoder/AlgoHedgeConfigInfoImplEncoder";

import * as CubiqTS from "../../index";
import { AlgoHedgeConfigInfo } from "../AlgoHedgeConfigInfo";

export class AlgoHedgeConfigInfoImpl extends ConcreteEncodable implements AlgoHedgeConfigInfo {
  public static enType: string = "com.bcdfx.model.AlgoHedgeConfigInfoImpl";

  /*FID=1*/
  public algoHedgeId: CubiqTS.Long | null = null;
  /*FID=2*/
  public traderGroupId: CubiqTS.Long | null = null;
  /*FID=3*/
  public traderGroupNm: string;
  /*FID=4*/
  public enabledFg: boolean;
  /*FID=5*/
  public orderType: string;
  /*FID=6*/
  public algoProfile: string;
  /*FID=7*/
  public startTimeOffset: CubiqTS.Long | null = null;
  /*FID=8*/
  public endTimeOffset: CubiqTS.Long | null = null;
  /*FID=9*/
  public strategyParams: Array<CubiqTS.StrategyParameter> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AlgoHedgeConfigInfoImplEncoder.Instance;
    this.setEncodableType(AlgoHedgeConfigInfoImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AlgoHedgeConfigInfoImpl[" +
      "algoHedgeId=" +
      this.algoHedgeId +
      "traderGroupId=" +
      this.traderGroupId +
      "traderGroupNm=" +
      this.traderGroupNm +
      "enabledFg=" +
      this.enabledFg +
      "orderType=" +
      this.orderType +
      "algoProfile=" +
      this.algoProfile +
      "startTimeOffset=" +
      this.startTimeOffset +
      "endTimeOffset=" +
      this.endTimeOffset +
      "strategyParams=" +
      this.strategyParams +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
